export default "/_next/static/assets/DunbarTall-ExtraBold_3a122cf6871e159fd1ba156685130aff.woff2";